var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.995 32.11C25.4434 33.6142 23.7492 33.3767 22.1184 32.6642C20.3925 31.9358 18.8092 31.9042 16.9884 32.6642C14.7084 33.6458 13.505 33.3608 12.1434 32.11C4.4167 24.1458 5.5567 12.0175 14.3284 11.5742C16.4659 11.685 17.9542 12.7458 19.205 12.8408C21.0734 12.4608 22.8625 11.3683 24.8575 11.5108C27.2484 11.7008 29.0534 12.6508 30.2409 14.3608C25.3009 17.3217 26.4725 23.8292 31.0009 25.65C30.0984 28.025 28.9267 30.3842 26.9792 32.1258L26.995 32.11ZM19.0467 11.4792C18.8092 7.94833 21.675 5.035 24.9684 4.75C25.4275 8.835 21.2634 11.875 19.0467 11.4792Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacIcon);
export default __webpack_public_path__ + "static/media/mac-icon.47320c47bc2b99548105841bbe77d531.svg";
export { ForwardRef as ReactComponent };